export const PRODUCT_PLACEHOLDER_URL = 'https://valleyapi-dr9y.onrender.com/data/placeholder.jpg';

const API_BASE = 'https://valleyapi-dr9y.onrender.com';

export const getProductImageUrl = (value) => {
  const image = String(value || '').trim();
  const normalizedImage = image.toLowerCase();

  if (!image || ['none', 'null', 'undefined', 'n/a', 'na'].includes(normalizedImage)) {
    return PRODUCT_PLACEHOLDER_URL;
  }

  if (/^https?:\/\//i.test(image)) return image;
  if (image.startsWith('/data/')) return `${API_BASE}${image}`;
  if (image.startsWith('data/')) return `${API_BASE}/${image}`;

  return `${API_BASE}/data/${image.replace(/^\/+/, '')}`;
};

export const normalizeProductImages = (value, legacyImage = null) => {
  let images = value;
  if (typeof images === 'string') {
    try {
      images = JSON.parse(images);
    } catch {
      images = [];
    }
  }
  if (!Array.isArray(images)) images = [];

  return [...new Set([legacyImage, ...images]
    .map((image) => String(image || '').trim())
    .filter((image) => image && !['none', 'null', 'undefined'].includes(image.toLowerCase())))]
    .slice(0, 8);
};

export const useProductImageFallback = (event) => {
  const image = event.currentTarget;
  image.onerror = null;
  image.src = PRODUCT_PLACEHOLDER_URL;
};
